import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../../../shared.module';
import { TranslocoModule } from '@ngneat/transloco';
import { SelectOption } from '../../../../inputs/select/model/select-option';
import * as dayjs from 'dayjs';


@Component({
  selector: 'psc-price-date-picker',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, SharedModule, TranslocoModule],
  templateUrl: './price-date-picker.component.html',
})
export class PriceDatePickerComponent implements OnInit {
  @Input() dateForm: FormGroup;
  months: SelectOption[] = [];
  dates: SelectOption[] = [];

  ngOnInit() {
    this.generateMonths();

    this.dateForm.get('month')?.valueChanges.subscribe(selectedMonth => {
      this.generateDates(selectedMonth);
    });

    this.generateDates(this.dateForm.get('month')?.value);
  }

  generateMonths() {
    for (let i = 1; i <= 12; i++) {
      this.months.push({
        value: this.addZeroIfLessThanTen(i),
        label: dayjs().month(i - 1).format('MMMM'),
      });
    }
  }

  generateDates(selectedMonth: number) {
    const totalDays = dayjs(`2021-${ selectedMonth }-01`).daysInMonth(); // year is a placeholder
    this.dates = Array.from({ length: totalDays }, (_, i) => ({
      value: this.addZeroIfLessThanTen(i + 1),
      label: i + 1,
    } as SelectOption));
  }

  addZeroIfLessThanTen(num: number) {
    return num < 10 ? '0' + (num).toString() : (num).toString();
  }

}
